import {Component, Input, OnInit} from '@angular/core';
import {FormGroup} from '@angular/forms';
import * as _sh from 'lodash';

import {RequestDataService} from './../../service/request-data.service';
import {UtilsService} from "../../service/utils.service";

@Component({
  selector: 'app-select',
  templateUrl: './select.component.html',
  styleUrls: ['./select.component.css']
})
export class SelectComponent implements OnInit {

  @Input() hulkForm: FormGroup;
  @Input() hulkColumn: any;

  @Input() bindModel: any;

  constructor(private requestDataService: RequestDataService,
              private utils: UtilsService
  ) {
  }

  modelChange(model) {
    if (this.utils.Base_HasValue(model)) {
      if (this.bindModel) {
        this.bindModel[this.hulkColumn.column] = model;
      } else {
        this.hulkColumn.model = model;
      }
      if (this.utils.Base_HasValue(this.hulkColumn.columnGroup)
        && this.hulkColumn.columnGroup.length) {
        let findValue = _sh.find(this.hulkColumn['itemArray'],{'code': model});
        _sh.each(this.hulkColumn.columnGroup, (item) => {
          item['model'] = findValue[item['fromValue']];
        });
      }
    }
    else {
      if (this.bindModel) {
        this.bindModel[this.hulkColumn.column] = null;
      } else {
        this.hulkColumn.model = null;
      }
      if (this.utils.Base_HasValue(this.hulkColumn.columnGroup)
          && this.hulkColumn.columnGroup.length) {
        _sh.each(this.hulkColumn.columnGroup, (item) => {
          item['model'] = null;
        });
      }
    }
  }

  ngOnInit(): void {
    this.hulkColumn.lableSpan = this.hulkColumn.lableSpan || 9;
    this.hulkColumn.itemSpan = this.hulkColumn.itemSpan || 15;
    if (!this.hulkColumn.itemArray && this.hulkColumn.dictionary) {
      this.requestDataService.getDataByCondition(this.hulkColumn.dictionary).subscribe(result => {
        this.hulkColumn.itemArray = result['data'] || [];
      });
    }
  }

}
